import {
  resultImage1,
  resultImage2,
  resultImage3,
  resultImage4,
} from "../../assets/realResultImages";
import essencaLogo from "../../assets/essenca-optimized.png";
import estethicalLogo from "../../assets/estethica-optimized.png";
import getcoLogo from "../../assets/getco-optimized.png";
import metahomeLogo from "../../assets/metahome-optimized.png";
import technohomeLoogo from "../../assets/technohome-optimized.png";

const homeAR = {
  nav: {
    services: "الخدمات",
    process: "المنهجية",
    results: "النتائج",
    pricing: "الأسعار",
    faq: "الأسئلة",
    contact: "تواصل معنا",
  },
  seo: {
    title: "QuadroCode | شركة تطوير برمجيات",
    description:
      "تطوّر QuadroCode مواقع وتطبيقات ويب وموبايل وحلول برمجية مخصصة. تصميم UI/UX، واجهات API، تكاملات، ودعم مستمر — بأداء وقابلية توسع.",
  },
  home: {
    hero: {
      badge: "#شركة تطوير برمجيات ناشئة",
      titleLine1: "ابتكر، ابنِ، وتوسّع —",
      titleLine2: "رؤيتك، شيفرتنا",
      descriptionLine1:
        "نطوّر مواقع وتطبيقات ويب وحلول برمجية تساعد عملك على النمو.",
      descriptionLine2:
        "تصميم UI/UX واضح، بنية قابلة للتوسع، وتسليم موثوق — من مواقع بسيطة إلى منصات متقدمة.",
      cta: "ابدأ الآن",
      checks: ["تطوير تطبيقات ويب", "مواقع وأنظمة CMS", "تطوير تطبيقات الجوال"],
    },

    services: {
      titleLine1: "حلول برمجية،",
      titleLine2: "مبنية للتوسع",
      subtitleLine1:
        "من المواقع إلى المنصّات المخصّصة — نقدّم UI/UX نظيف، بنية قوية،",
      subtitleLine2:
        "وتنفيذ موثوق يدعم نمو الأعمال الحقيقي.",
      cardCta: "تواصل معنا",
      sectionCta: "عرض المزيد",
      cards: [
        {
          id: 1,
          variant: "ux",
          title: "تصميم UI/UX",
          points: [
            "واجهات تركز على المستخدم لزيادة الوضوح والتحويل.",
            "نظام تصميم ثابت يحافظ على الاتساق مع النمو.",
            "تصميم متجاوب يعمل على كل الأجهزة والمقاسات.",
          ],
        },
        {
          id: 2,
          variant: "webapp",
          title: "تطوير تطبيقات الويب",
          points: [
            "لوحات تحكم وبوابات وتطبيقات SaaS بهيكل نظيف.",
            "واجهات API آمنة وبنية خلفية قابلة للتوسع.",
            "أداء عالي مع كود قابل للصيانة على المدى الطويل.",
          ],
        },
        {
          id: 3,
          variant: "cms",
          title: "مواقع وCMS",
          points: [
            "مواقع سريعة جاهزة للسيو من اليوم الأول.",
            "إدارة محتوى سهلة للفرق غير التقنية.",
            "صفحات مرنة تدعم التوسع مستقبلاً.",
          ],
        },
      ],
      extraCards: [
        {
          id: 4,
          variant: "perf",
          title: "تحسين الأداء",
          points: [
            "تحسين السرعة وتجربة المستخدم وCore Web Vitals.",
            "تحسين الصور والملفات والرندر حيث يلزم.",
            "حلول عملية تقلل وقت التحميل ومعدل الارتداد.",
          ],
        },
        {
          id: 5,
          variant: "support",
          title: "صيانة ودعم",
          points: [
            "تحديثات ومراقبة وتحسينات مستمرة.",
            "إصلاح أخطاء مع تقارير واضحة وأولويات.",
            "إصدارات مستقرة بدون كسر بيئة الإنتاج.",
          ],
        },
        {
          id: 6,
          variant: "devops",
          title: "DevOps والنشر",
          points: [
            "أساسيات CI/CD لنشر موثوق.",
            "إعداد خوادم لينكس والدومين وSSL والمراقبة.",
            "تقوية الإنتاج وتوحيد البيئات.",
          ],
        },
        {
          id: 7,
          variant: "mobile",
          title: "تطوير تطبيقات الموبايل",
          points: [
            "تطبيقات متعددة المنصات بواجهة نظيفة وأداء قريب للـ Native.",
            "بنية منظمة قابلة للصيانة مع التوسع.",
            "تسجيل دخول، دفع، إشعارات، وتسليم جاهز للمتاجر.",
          ],
        },
        {
          id: 8,
          variant: "api",
          title: "تكامل APIs",
          points: [
            "ربط موثوق مع APIs خارجية وخدمات داخلية.",
            "مصادقة آمنة (JWT/OAuth) ومعالجة أخطاء واضحة.",
            "مزامنة بيانات مستقرة مع أداء عالي وCaching.",
          ],
        },
        {
          id: 9,
          variant: "ai",
          title: "وكلاء ذكاء اصطناعي",
          points: [
            "وكلاء ينفذون مهام لتسريع العمل وتقليل اليدوي.",
            "وكلاء مرتبطون بالأدوات وAPIs مع قيود وتسجيل.",
            "بنية قابلة للنشر ومبنية للاستخدام الحقيقي على نطاق واسع.",
          ],
        },
      ],
    },

    process: {
      titleLine1: "منهجية واضحة،",
      titleLine2: "مبنية للتسليم",
      subtitleLine1: "نبقي الأمور بسيطة: نفهم الهدف، نصمم بوضوح، نطوّر ببنية قوية،",
      subtitleLine2: "ونطلق بثقة — ثم نحسّن بناءً على النتائج الفعلية.",
      cards: [
        {
          number: "01",
          variant: "discover",
          title: "فهم وتحديد النطاق",
          text: "نحدد الأهداف والمستخدمين والمتطلبات، ثم نضع نطاقًا وزمنًا واضحين لتجنب المفاجآت.",
        },
        {
          number: "02",
          variant: "design",
          title: "تصميم ونموذج أولي",
          text: "نضع اتجاه UI/UX واضح ونبني نموذجًا لأولويات التدفق لضمان تجربة صحيحة من البداية.",
        },
        {
          number: "03",
          variant: "build",
          title: "تطوير وتكامل",
          text: "نطوّر ببنية قابلة للتوسع وواجهات API نظيفة وتكاملات تناسب سير عملك.",
        },
        {
          number: "04",
          variant: "launch",
          title: "اختبار وإطلاق",
          text: "نختبر على الأجهزة المختلفة، نعالج الحالات الخاصة، ونجهز الإطلاق باستقرار وأداء قوي.",
        },
        {
          number: "05",
          variant: "grow",
          title: "دعم وتحسين",
          text: "بعد الإطلاق نتابع التحسين: ميزات جديدة، أداء أفضل، ودعم مستمر لتطوير المنتج.",
        },
      ],
    },

    results: {
      titleLine1: "أعمال واقعية،",
      titleLine2: "نتائج جاهزة للإنتاج",
      subtitleLine1: "نبني حلولًا عملية — واجهات واضحة، وظائف موثوقة،",
      subtitleLine2: "وأنظمة قابلة للتوسع مع نمو عملك.",
      cta: "تواصل معنا",
      items: [
        {
          id: 1,
          imgURL: resultImage1.src,
          imgSrcSet: resultImage1.srcSet,
          title: "أساس متجر إلكتروني",
          text: "متجر سريع ومتجاوب بهيكل واضح وصفحات منتجات وتجربة تساعد على التحويل.",
        },
        {
          id: 2,
          imgURL: resultImage2.src,
          imgSrcSet: resultImage2.srcSet,
          title: "تطبيق تعاون للفِرق",
          text: "فكرة أداة داخلية آمنة بصلاحيات مستخدمين وسير عمل قابل للتوسع وبنية قوية.",
        },
        {
          id: 3,
          imgURL: resultImage3.src,
          imgSrcSet: resultImage3.srcSet,
          title: "تحديث واجهة حديثة",
          text: "تطوير UI يركز على الوضوح والاتساق والتجاوب على مختلف الأجهزة.",
        },
        {
          id: 4,
          imgURL: resultImage4.src,
          imgSrcSet: resultImage4.srcSet,
          title: "موقع عرض العلامة",
          text: "هيكل موقع تسويقي نظيف يعرض الخدمات ويبني الثقة ويزيد طلبات التواصل.",
        },
      ],
    },

    pricing: {
      titleLine1: "أسعار مرنة،",
      titleLine2: "بحسب نطاق العمل",
      subtitle:
        "اختر باقة بداية وسنحدد السعر النهائي حسب الميزات والصفحات والتكاملات والمدة الزمنية.",
      tabs: ["شهري", "ربع سنوي", "سنوي"],
      priceSuffix: "ابتداءً من",
      cta: "ابدأ الآن",
      note:
        "السعر النهائي يعتمد على المتطلبات. نقدم نطاقًا واضحًا وجدولًا زمنيًا وتسعيرًا ثابتًا بعد مكالمة قصيرة.",
      plans: [
        {
          id: 1,
          variant: "starter",
          title: "موقع بداية",
          desc:
            "مناسب للأعمال الجديدة التي تحتاج موقعًا سريعًا ونظيفًا لبدء استقبال العملاء وبناء الثقة.",
          priceFrom: "$499",
          features: [
            "تصميم متجاوب حديث",
            "تهيئة SEO أساسية (العناوين والهيكل)",
            "قسم تواصل + تدفق CTA",
            "أصول محسنة للأداء",
            "قابلية للتوسّع مستقبلًا",
          ],
        },
        {
          id: 2,
          variant: "business",
          title: "موقع أعمال",
          desc:
            "مناسب لشركات الخدمات التي تحتاج أقسام/صفحات أكثر، هيكل محتوى أقوى، وتكاملات.",
          priceFrom: "$1,299",
          features: [
            "استراتيجية محتوى وأقسام أعمق",
            "تحسينات UX لزيادة التحويل",
            "تكاملات (واتساب، نماذج، بريد)",
            "أساسيات SEO داخل الصفحة",
            "نشر وتجهيز إنتاج أساسي",
          ],
        },
        {
          id: 3,
          variant: "mobile",
          title: "تطبيق موبايل",
          desc:
            "مناسب للشركات التي تحتاج تطبيق موبايل للعملاء أو للاستخدام الداخلي مع تجربة استخدام قوية وتكامل ",
          priceFrom: "$2,499",
          features: [
            "مسار إطلاق على iOS وAndroid",
            "تجربة استخدام وتدفقات موبايل واضحة",
            "جاهز للتكامل مع API وBackend",
            "تسجيل دخول وإشعارات ومنطق التطبيق الأساسي",
            "دعم إطلاق المتاجر",
          ],
        },
        {
          id: 4,
          variant: "custom",
          title: "برمجيات مخصصة",
          desc:
            "مناسب للتطبيقات والبوابات ولوحات التحكم والأتمتة والمنصات التي تحتاج Backend وواجهات API وصلاحيات.",
          priceFrom: "حسب الطلب",
          features: [
            "تخطيط وبنية + خارطة طريق",
            "Backend وواجهات API وتكاملات",
            "صلاحيات وتدفقات آمنة",
            "نشر وبنية قابلة للتوسع",
            "خيارات صيانة وتطوير مستمر",
          ],
        },
        
      ],
    },

    trusted: {
      title: "موثوق من شركاء",
      aria: "شريط شعارات الشركاء",
      logoAlt: "شعار الشريك {n}",
      logos: [
        metahomeLogo,
        essencaLogo,
        technohomeLoogo,
        estethicalLogo,
        getcoLogo,
      ],
    },

    footer: {
      faq: {
        title: "إجابات على الأسئلة الشائعة",
        subtitle: "إجابات سريعة وواضحة حول طريقة عملنا وما يمكنك توقعه.",
        cta: "تواصل معنا",
        items: [
          {
            id: 1,
            q: "كم يستغرق إنشاء موقع؟",
            a: "غالبًا 1–3 أسابيع حسب عدد الصفحات وجاهزية المحتوى وسرعة الملاحظات. المشاريع الأكبر تحتاج وقتًا أطول.",
          },
          {
            id: 2,
            q: "هل تطورون برمجيات مخصصة وليس فقط مواقع؟",
            a: "نعم. نطور تطبيقات ويب ولوحات تحكم وبوابات وأتمتة — مع Backend وواجهات API وصلاحيات وتكاملات.",
          },
          {
            id: 3,
            q: "هل تساعدون في إعادة تصميم موقع موجود؟",
            a: "نعم. نحسن UI/UX والهيكل والأداء ونحافظ على ما يعمل بالفعل دون الإضرار باستراتيجية المحتوى.",
          },
          {
            id: 4,
            q: "هل تقدمون صيانة ودعم؟",
            a: "نعم. نوفر دعمًا مستمرًا للتحديثات وإصلاح الأخطاء والتحسينات والمراقبة حسب الحاجة.",
          },
          {
            id: 5,
            q: "هل مواقعكم متجاوبة وسريعة؟",
            a: "نعم. نبني تصميمًا متجاوبًا ونحسن الأصول لدعم أداء وتجربة مستخدم جيدة على مختلف الأجهزة.",
          },
          {
            id: 6,
            q: "كيف يتم تسعير المشاريع؟",
            a: "نبدأ بباقات أساسية ثم نحدد السعر النهائي حسب النطاق: صفحات، ميزات، تكاملات، والمدة. تحصل على نطاق واضح وتسعير ثابت.",
          },
        ],
      },

      cta: {
        title: "ابدأ مشروعك مع QuadroCode",
        button: "ابدأ الآن",
      },

      brand: {
        name: "QuadroCode",
        logoAlt: "شعار QuadroCode",
        taglineLine1: "ابتكر، ابنِ، وتوسّع —",
        taglineLine2: "رؤيتك، شيفرتنا",
        contactBtn: "تواصل معنا",
      },

      contact: {
        emailLabel: "البريد",
        phoneLabel: "الهاتف",
        email: "",
        phone: "",
        location: "",
        form: {
          title: "حدثنا عن مشروعك",
          subtitle: "استخدم النموذج لمشاركة نطاق مشروعك أو جدوله الزمني أو فكرتك، وسيتواصل معك فريقنا.",
          submit: "أرسل الاستفسار",
          success: "تم إرسال الاستفسار بنجاح.",
          error: "حدث خطأ. حاول مرة أخرى.",
          sending: "جاري إرسال الاستفسار...",
          emailIntro: "استفسار مشروع جديد من الموقع.",
          defaultSubject: "استفسار مشروع جديد",
          fields: {
            name: "الاسم",
            email: "البريد",
            subject: "الموضوع",
            message: "الرسالة",
          },
          placeholders: {
            name: "اسمك",
            email: "you@company.com",
            subject: "نطاق المشروع",
            message: "اكتب ما تحتاج منا بناءه.",
          },
        },
      },

      socialsAria: "روابط التواصل",
      socials: {
        whatsapp: "",
        instagram: "",
        linkedin: "",
        x: "",
      },

      links: {
        col1: {
          title: "القائمة",
          items: [
            { label: "الخدمات", href: "#services" },
            { label: "المنهجية", href: "#process" },
            { label: "النتائج", href: "#results" },
            { label: "الأسعار", href: "#pricing" },
          ],
        },
        col2: {
          title: "الشركة",
          items: [
            { label: "الأسئلة", href: "#faq" },
            { label: "تواصل معنا", href: "#contact" },
          ],
        },
        col3: {
          title: "الخدمات",
          items: [
            { label: "تصميم UI/UX", href: "#services" },
            { label: "تطوير ويب", href: "#services" },
            { label: "برمجيات مخصصة", href: "#services" },
          ],
        },
      },

      copyright:
        "حقوق النشر © {year} QuadroCode — شركة تطوير برمجيات",
    },
  },
};

export default homeAR;

